import * as React from 'react';
const SvgCustom = (props) => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#custom_svg__a)"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M77.63 118.647a59.505 59.505 0 0 0 14.421-6.667l-2.563-12.593a48.79 48.79 0 0 0 8.957-9.047l12.465 2.587a60.6 60.6 0 0 0 7.762-18.894l-10.635-7.066c.271-2.094.423-4.227.423-6.4 0-2.174-.152-4.3-.423-6.394l10.635-7.073a60.6 60.6 0 0 0-7.762-18.893l-12.465 2.586a49.409 49.409 0 0 0-8.957-9.046L92.051 9.16a59.458 59.458 0 0 0-18.72-7.833L66.32 12.06a49.616 49.616 0 0 0-6.328-.427c-2.14 0-4.254.16-6.335.427L46.656 1.327a59.458 59.458 0 0 0-18.72 7.833l2.563 12.587a49.2 49.2 0 0 0-8.958 9.046L9.076 28.207A60.745 60.745 0 0 0 1.314 47.1l10.636 7.073a49.8 49.8 0 0 0-.43 6.394c0 2.166.159 4.306.43 6.4L1.314 74.033a60.484 60.484 0 0 0 7.762 18.894l12.465-2.587a48.995 48.995 0 0 0 8.958 9.047l-2.563 12.593a59.7 59.7 0 0 0 14.473 6.687" />
      <path d="M60 31.02c-15.854 0-31.635 13.307-30.241 31.56.522 6.84 3.461 13.547 7.444 18.44 9.057 11.127 8.007 10.067 8.29 15.54h29.02c.284-5.473-.767-4.407 8.29-15.54 3.977-4.887 6.916-11.593 7.445-18.44C91.64 44.333 75.86 31.02 60.007 31.02H60Z" />
      <path d="M45.487 96.553v5.367c0 8.1 6.507 14.667 14.526 14.667 8.073 0 14.599-6.647 14.526-14.8l-.026-5.227M60 90V58M48.969 64.107 60 75.24l11.032-11.133" />
    </g>
    <defs>
      <clipPath id="custom_svg__a">
        <path fill="#fff" d="M0 0h120v120H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCustom;
